export default __webpack_public_path__ + "static/media/responsibility.ce0902c8.svg";